import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import CrmEnrichmentJobNameModal from "app/pages/sales-intelligence/modules/crm-enrichment/components/CrmEnrichmentJobNameModal/CrmEnrichmentJobNameModal";
import crmEnrichmentManageTrackingService from "app/pages/sales-intelligence/modules/crm-enrichment/services/tracking/trackingService";
import { setRenameModalOpen } from "app/pages/sales-intelligence/modules/crm-enrichment/store/action-creators";
import { selectIsRenameModalOpen } from "app/pages/sales-intelligence/modules/crm-enrichment/store/selectors";
import type { CrmEnrichmentJob } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

import useHsEnrichmentJobRenameMutation from "../../mutations/useHsEnrichmentJobRenameMutation";

type CrmEnrichmentJobRenameModalContainerProps = {
    job: CrmEnrichmentJob;
    onClose?: VoidFunction;
};

const CrmEnrichmentJobRenameModalContainer = ({ job, onClose }: CrmEnrichmentJobRenameModalContainerProps) => {
    const dispatch = useDispatch();

    const isModalOpened = useSelector(selectIsRenameModalOpen);

    const { name, id } = job;

    const [jobName, setJobName] = useState(name);

    const {
        mutate: mutateRename,
        isPending: isLoadingRename,
        isSuccess: isSuccessRename,
    } = useHsEnrichmentJobRenameMutation();

    const handleCloseModal = () => {
        dispatch(setRenameModalOpen(false));

        setJobName(name);
        onClose?.();
    };

    const handleSaveJobName = () => {
        crmEnrichmentManageTrackingService.trackRenameJob(jobName, name, "hubspot");
        mutateRename({ jobId: id, name: jobName });
    };

    useEffect(() => {
        if (isSuccessRename) {
            dispatch(setRenameModalOpen(false));
        }
    }, [isSuccessRename]);

    return (
        <CrmEnrichmentJobNameModal
            crmProvider="hubspot"
            isRenameMode
            isOpened={isModalOpened}
            onClose={handleCloseModal}
            jobName={jobName}
            onChangeJobName={setJobName}
            isSubmitDisabled={!jobName.trim() || jobName === name}
            isSubmitLoading={isLoadingRename}
            onSaveName={handleSaveJobName}
        />
    );
};

export default CrmEnrichmentJobRenameModalContainer;
